import { useInsightsLensContext } from '@upright/ui/common/upright/core/impact-lenses/insights/common/use-insights-lens-context';
import { getInsightInfoBoxDataWithBoundsForSelection } from '@upright/ui/common/upright/core/impact-lenses/insights/common/utils';
import { NarrativeInfoBox } from '@upright/ui/common/upright/core/impact-lenses/insights/info-boxes/narrative-info-box';
import { useCarouselContext, useCarouselLayout } from '../../../impact-lens-profile/context';

export function InsightsInfoBoxes() {
  const { lensIndex, previousLensIndex } = useCarouselContext();
  const baseLayout = useCarouselLayout();
  const lensContext = useInsightsLensContext();
  const items = lensContext?.data.insights;
  if (!items) {
    return <></>;
  }
  const boxData = getInsightInfoBoxDataWithBoundsForSelection(
    baseLayout,
    items,
    lensIndex,
    previousLensIndex,
    lensContext.selection,
  );
  const boxes = boxData.map(d => {
    const key = d.data.map(item => item.text).join('');
    return (
      <NarrativeInfoBox
        key={key}
        id={key}
        insights={d.data}
        x={d.bounds.x1}
        y={d.bounds.y1}
        width={d.bounds.width}
        height={d.bounds.height}
      />
    );
  });

  return <>{boxes}</>;
}
